module.exports = __webpack_public_path__ + "img/heart_low.44798a2f.png";